import { createApp } from 'vue'
import { createHead } from '@vueuse/head'
import App from './App.vue'
import router from './router'
import store from './store'
import logger from '@/utils/logger'
import './api/index.js'
import './styles/variables.css'
import './styles/globals.css'

const app = createApp(App)
const head = createHead()

app.config.errorHandler = (err, vm, info) => {
  logger.error('Vue error caught', {
    error: err.message,
    info,
    stack: err.stack
  })
}

app.use(store)
app.use(router)
app.use(head)
app.mount('#app')